import _ from 'lodash';

export const weeks = (numberOfWeeks) => {
  let currentDate = new Date();
  currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

  return _.range(numberOfWeeks).map((week) => {
    return _.range(7).map((day) => {
      const _date = new Date();
      const dateToSet = currentDate.getDate() - (day + week * 7);
      _date.setDate(dateToSet);
      return _date;
    });
  });
};
